import { getContentDetail, getDoctorArticleDetail } from '@/api';

export default {
  namespaced: true,
  state: {
    article: {},
    trackCodeDetail: {},
  },
  getters: {},
  mutations: {
    SET_detail(state, { data, focus = false }) {
      if (focus) {
        state.article = data;
      } else {
        state.article = { ...state.article, ...data };
      }
    },
    SET_trackCodeDetail(state, data) {
      state.trackCodeDetail = { ...state.trackCodeDetail, ...data };
    },
  },
  actions: {
    async getPatientDetail({ commit }, params) {
      const { data } = await getContentDetail(params);
      commit('SET_detail', { data, focus: true });
      return data
    },
    async getDoctorDetail({ commit }, params) {
      const { data } = await getDoctorArticleDetail(params);
      commit('SET_detail', { data, focus: true });
      return data
    },
  },
};
